'use client'
import React, { FC } from 'react'

interface RadioInputProps {
  label: string
  id: string
  checked: boolean
  onChange: () => void
  testId?: string
}

const RadioInput: FC<RadioInputProps> = ({ label, checked, onChange, id, testId }) => {
  return (
    <label data-testid={testId} className="flex cursor-pointer items-center gap-x-2.5">
      <div className="border-primary-base relative flex size-4.5 items-center justify-center rounded-full border bg-white">
        {checked && <div className="bg-primary-base size-2.5 rounded-full" />}
      </div>
      <span className="text-neutral-darker text-sm leading-none">{label}</span>
      <input type="radio" value={id} checked={checked} onChange={onChange} className="sr-only" />
    </label>
  )
}

export default RadioInput
